import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import CompanyLocation from '@/model/CompanyLocation'

@Singleton
export default abstract class CompanyLocationApi {

    abstract list(): Promise<Array<CompanyLocation>>
}

class CompanyLocationApiImpl extends BaseApi implements CompanyLocationApi {

    protected urlPrefix = 'company/location'

    list(): Promise<Array<CompanyLocation>> {
        return this.axios.get('list')
    }
}

Container.bind(CompanyLocationApi).to(CompanyLocationApiImpl)
